import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'

//Parameters
const Parameters = {
    BlockNumbers: 1000,
    objectTransformRandomness: 55,
    objectrotationrandomness: 0.6,
    rotationSpeed:0.0001,
    ambientlightColor:0x6f586d,
    pointlightColor:0x2154ba,
    BGColor:0x171617,
}

// Setup stuff
const canvas = document.querySelector('canvas.webgl')
const scene = new THREE.Scene()
scene.background = new THREE.Color( Parameters.BGColor )
//Setup some gui
const gui = new GUI({})
gui.addColor(Parameters,'BGColor')
    .onChange(()=>{scene.background = new THREE.Color( Parameters.BGColor )})
gui.add(Parameters, 'rotationSpeed')
    .min(0)
    .max(0.1)
    .step(0.0001)
    .name('SPEED')
    
// load texures
var textureLoader = new THREE.TextureLoader();

var textures = new Array(189).fill(0).map((_, index) => {
  return textureLoader.load('minecraft/' + pad(index+1, 3) + '.png',TexureFilter);
});
function TexureFilter(textureee) 
{
    textureee.magFilter = THREE.NearestFilter
    textureee.genereateMipmaps = false
}


//Camera
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight}

const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.z = 12
scene.add(camera)

// lights

const ambientlight = new THREE.AmbientLight(Parameters.ambientlightColor,1)
const pointlight = new THREE.PointLight(Parameters.pointlightColor,1)

gui.addColor(Parameters,'ambientlightColor')
    .onChange(()=>{ ambientlight.color.set(Parameters.ambientlightColor)})
    .name('Ambient Color')
gui.addColor(Parameters,'pointlightColor')
    .onChange(()=>{ pointlight.color.set(Parameters.pointlightColor)})
    .name('Light Color')

    scene.add(ambientlight)
scene.add(pointlight)

//make cubes
const geometry = new THREE.BoxGeometry(1,1,1)

function InitializeCubes()
{
    for( var i = scene.children.length - 1; i >= 3; i--) { 
        scene.remove(scene.children[i]); 
   }
    for (let i=0;i<Parameters.BlockNumbers;i++)
    {
        const material = new THREE.MeshLambertMaterial({map:textures[i%textures.length]})
        const box = new THREE.Mesh(geometry,material)
        scene.add(box)
    }
    randomizeTransform()
    randomizeRotation()
}
InitializeCubes()
gui.add(Parameters,'BlockNumbers')
    .min(1)
    .max(10000)
    .step(1)
    .name('Amount (may lag if too much)')
    .onChange(()=>
        {InitializeCubes()})


//randomize transforms
function randomizeTransform(){
    for (let i=1;i<scene.children.length;i++)
    {
        scene.children[i].position.x = (Math.random()-0.5) * Parameters.objectTransformRandomness
        scene.children[i].position.y = (Math.random()-0.5) * Parameters.objectTransformRandomness
        scene.children[i].position.z = (Math.random()-0.5) * Parameters.objectTransformRandomness
    }}
gui.add(Parameters, 'objectTransformRandomness')
    .min(0)
    .max(100)
    .step(0.1)
    .name('Volume size')
    .onChange(()=>
    {randomizeTransform()})


function randomizeRotation(){
    for (let i=1;i<scene.children.length - 1;i++)
    {
        scene.children[i].rotation.x = (Math.random()-0.5)  * Parameters.objectrotationrandomness
        scene.children[i].rotation.y = (Math.random()-0.5)  * Parameters.objectrotationrandomness
        scene.children[i].rotation.z = (Math.random()-0.5)  * Parameters.objectrotationrandomness
    }}
gui.add(Parameters, 'objectrotationrandomness')
    .min(0)
    .max(5)
    .step(0.01)
    .name('rotation variety')
    .onChange(()=>
    {randomizeRotation()})







//controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)

//Debug

window.addEventListener ('resize', () => 
{
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(window.devicePixelRatio)
})

//animation
const clock = new THREE.Clock() 
let time = Date.now()

const tick = () => {
    //time shit
    const timecounter = clock.getElapsedTime()
    const currentTime = Date.now()
    const deltaTime = currentTime - time
    time = currentTime

    function rotateovertime(){
        for (let i=0;i<scene.children.length - 1;i++)
        {
            scene.children[i].rotation.y += (deltaTime)* Parameters.rotationSpeed
           // scene.children[i].rotation.y = timecounter
        }}
    rotateovertime()

    controls.update()
    renderer.render(scene, camera)
    window.requestAnimationFrame(tick)
}
tick()


//helper functions
function pad (num, size) {
    var length =('00000' + num)
    return length.substring(length.length - size);
  }

function repeatTextures (i) {
    if (i>textures.length){
        return i
    }
}